import { BillingStatus } from '@innovationdepartment/proxima-sdk-axios';
import { BillingPlanLabels, type BrandInfoProps } from 'types/brandOverview';
import BrandOverviewPlanView from './BrandOverviewPlan.View';

const BrandOverviewPlan = ({ billing, apiLoading }: BrandInfoProps) => {
  const isCancelled = billing?.status === BillingStatus.Cancelled;
  const isGrace = billing?.status === BillingStatus.Grace;
  const isTrial = billing?.status === BillingStatus.Trial;

  let plan: string = (billing && BillingPlanLabels[billing.plan]) || 'No plan';

  if (isCancelled) plan = 'No plan';
  else if (isTrial) plan = `Trial`;

  if (isGrace) plan = `${plan} (Grace period)`;

  return <BrandOverviewPlanView plan={plan} loading={apiLoading.billing} />;
};

export default BrandOverviewPlan;
